import type { InvoiceSettingsFormState } from '@/types/settings'

export const REMINDER_INTERVAL_MIN = 1
export const REMINDER_INTERVAL_MAX = 365

export const DEFAULT_INVOICE_SETTINGS_FORM_STATE: InvoiceSettingsFormState = {
  numbering_format: 'INV-YYYY-',
  default_payment_terms: '30',
  reminder_intervals: [7, 14, 21, 30],
  overdue_blocking: false,
  blocking_mode: '',
}

export function isValidReminderIntervalDay(n: number): boolean {
  return (
    Number.isInteger(n) &&
    n >= REMINDER_INTERVAL_MIN &&
    n <= REMINDER_INTERVAL_MAX
  )
}

/** Parse comma/space-separated user input into valid reminder day numbers. */
export function parseReminderIntervalInput(raw: string): number[] {
  return raw
    .split(/[,\s]+/)
    .map(s => s.trim())
    .filter(Boolean)
    .map(s => Number(s))
    .filter(isValidReminderIntervalDay)
}

/**
 * Normalize API or legacy values (number[] or comma-separated string) into
 * sorted unique reminder intervals.
 */
export function normalizeReminderIntervals(raw: unknown): number[] {
  if (Array.isArray(raw)) {
    return dedupeSortReminderIntervals(
      raw.map(v => Number(v)).filter(isValidReminderIntervalDay)
    )
  }
  if (typeof raw === 'string' && raw.trim()) {
    return dedupeSortReminderIntervals(parseReminderIntervalInput(raw))
  }
  return []
}

export function mergeReminderIntervals(
  existing: number[],
  additions: number[]
): number[] {
  return dedupeSortReminderIntervals([...existing, ...additions])
}

function dedupeSortReminderIntervals(days: number[]): number[] {
  return Array.from(new Set(days)).sort((a, b) => a - b)
}
